<template>
    <h1>Identity Verification Details</h1>
    <Divider />
    <div class="m-auto mb-12 mt-12 flex flex-col items-center pb-12">
        <b class="text-lg text-content-primary">Could not load report</b>
        <div class="text-base">There was an error loading the identity verification results</div>
        <div class="text-base">Please try again in a few moments</div>

        <DsButton
            class="mt-4 w-1/2"
            size="md"
            variant="primary"
            @click="$emit('try-reload')"
        >
            Try again
        </DsButton>

        <DsButton
            class="mt-4 w-1/2"
            size="md"
            variant="secondary"
            @click="$emit('close')"
        >
            Close
        </DsButton>
    </div>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/form/input/DsButton.vue';
import Divider from 'primevue/divider';

defineEmits(['try-reload', 'close']);
</script>
